import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterObjectByField',
  standalone: false,
})
@Injectable()
export class FilterObjectByFieldPipe implements PipeTransform {
  transform(items: any[], field: any, value: any): any[] {
    if (!items) return [];
    if (!value || value.length === 0) return items;
    return items.filter((it) => {
      if (it[field] === undefined || !value) return;
      return it[field]
        .toString()
        .toLowerCase()
        .includes(value.toString().toLowerCase());
    });
  }
}
